import loadable from '@loadable/component';

export const Manager = loadable(
  /* #__LOADABLE__ */ () =>
    import(/* webpackChunkName: "AssignedLearningManagerPage" */ './Manager'),
);
